export default (values) => {
    const errors = {}
    if (values.password !== values.passwordConfirm) {
      errors.passwordConfirm = 'Passwords do not match.';
    }
    return errors;
  }